/**
 * ForceVane CTA footer — marks the legal link that matches the current URL (aria-current).
 */
(function () {
  document.querySelectorAll('[data-fvcta-root]').forEach(function (root) {
    if (root.getAttribute('data-fvcta-bound') === '1') return;
    root.setAttribute('data-fvcta-bound', '1');

    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    root.querySelectorAll('.fvcta__legal-link[href]').forEach(function (a) {
      try {
        var u = new URL(a.href, window.location.origin);
        var p = u.pathname.replace(/\/+$/, '') || '/';
        if (p === path) a.setAttribute('aria-current', 'page');
      } catch (e) {
        /* ignore */
      }
    });
  });
})();
